import { DataTransformer } from './data.transformer';

export class DataArrayTransformer {
    static transform(array = []) {
        let filtered = [];
        array.data.map(function (item) {
            filtered.push(DataTransformer.transform(item));
        });
        const orders = filtered;
        Object.assign(orders, array.meta);
        return orders;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/orders/data-array.transformer.js